<template>
  <div>
    <div class="wrap">
      <div class="leading-10">
        <div>跨境收款信息</div>
        <div class="flex_row">
          <div class="item_title">跨境收款编码</div>
          <div class="item_conent">{{ collectionNo }}</div>
        </div>
      </div>

      <div class="leading-10">
        <div>账户信息（中文版）</div>
        <div class="flex_row">
          <div class="item_title">开户银行</div>
          <div class="item_conent">浙商银行成都分行营业部</div>
        </div>

        <div class="flex_row">
          <div class="item_title">账户名称</div>
          <div class="item_conent">现代金融控股（成都）有限公司客户备付金</div>
        </div>

        <div class="flex_row">
          <div class="item_title">账号</div>
          <div class="item_conent">6510000010120100813077</div>
        </div>

        <div class="flex_row">
          <div class="item_title">Cnaps Code</div>
          <div class="item_conent">316651000022</div>
        </div>

        <div class="flex_row">
          <div class="item_title">Swift Code</div>
          <div class="item_conent">ZJCBCN2N</div>
        </div>
      </div>

      <div class="leading-10">
        <div>账户信息（英文版）</div>
        <div class="flex_row">
          <div class="item_title">Name of Bank</div>
          <div class="item_conent">CHINA ZHE SHANG BANK</div>
        </div>

        <div class="flex_row">
          <div class="item_title">Name of Account</div>
          <div class="item_conent">MODERN FINANCIAL HOLDINGS(CHENGDU) CO LTD</div>
        </div>

        <div class="flex_row">
          <div class="item_title">Account</div>
          <div class="item_conent">6510000010120100813077</div>
        </div>

        <div class="flex_row">
          <div class="item_title">Cnaps Code</div>
          <div class="item_conent">316651000022</div>
        </div>

        <div class="flex_row">
          <div class="item_title">Swift Code</div>
          <div class="item_conent">ZJCBCN2N</div>
        </div>

        <div class="flex_row">
          <div class="item_title">Address</div>
          <div class="item_conent">NO.288 QINGCHUN ROAD SHANGCHENG DISTRICT HANGZHOU CHINA</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getMerchantType } from '@/api/crossborder/merchant/index'
export default {
  data: function () {
    return {
      collectionNo: '', // 收款编码
    }
  },

  created() {
    this.getMerchantType()
  },
  methods: {
    getMerchantType() {
      this.collectionNo = ''
      getMerchantType({ merNo: this.$store.getters.merNo })
        .then((res) => {
          this.collectionNo = res.data.exportPayeeNo || '获取数据出错...'
        })
        .catch((err) => {
          console.log('查询商户信息出错', err)
        })
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';
.wrap{
  padding: 48px 80px;
}
.leading-10 {
  line-height: 2.5rem;
}
.flex_row{
  display: flex;
  flex-direction: row;
}
.item_title{
  width: 10rem;
  font-size: 0.875rem;
  text-align: right;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  color: rgb(107 114 128)
}
.item_conent{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}



::v-deep .inputStyle .el-form-item__content {
  width: 270px;
}
::v-deep .inputStyle2 .el-form-item__content {
  width: 400px;
  padding-right: 20px;
}
::v-deep .operateStyle .el-form-item__content {
  width: 500px;
}
</style>

